import React, { type ReactElement } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './Login';
import PatientsList from './pages/PatientsList';
import PatientDetail from './pages/PatientDetail';
import logo from './logo.svg';
import './App.css';

function PrivateRoute({ children }: { children: ReactElement }) {
  const { access } = useAuth();
  return access ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<PrivateRoute><PatientsList /></PrivateRoute>} />
          <Route path="/app/patient/:id" element={<PrivateRoute><PatientDetail /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
